import patient from "app/store/patient/slice/patientSlice";
import transmission from "app/store/transmission/slice/transmissionSlice";
import { combineReducers } from "redux";

import { billingAmountApi } from "app/store/billingAmount/api/billingAmountApi";
import billingAmount from "app/store/billingAmount/slice/billingAmountSlice";

import { doctorAnalyticApi } from "app/store/dashboard/doctor_analytic/api/doctorAnalyticApi";
import doctorAnalytic from "app/store/dashboard/doctor_analytic/slice/doctorAnalyticSlice";

import { revenueAnalyticApi } from "app/store/dashboard/revenue_analytic/revenueAnalyticApi";
import { electronicDeviceApi } from "app/store/dashboard/electronic_device/electronicDeviceApi";
import { manufacturerListApi } from "app/store/dashboard/patient_analytic/api/manufacturerListApi";

import { patientAnalyticApi } from "app/store/dashboard/patient_analytic/api/patientAnalyticApi";
import patientAnalytic from "app/store/dashboard/patient_analytic/slice/patientAnalyticSlice";

import { surgeryProcedureApi } from "app/store/dashboard/surgery_types_procedures/api/surgeryProcedureApi";
import surgeryProcedure from "app/store/dashboard/surgery_types_procedures/slice/surgeryProcedureSlice";

import { transmissionAnalyticApi } from "app/store/dashboard/transmission_analytic/api/transmissionAnalyticApi";
import transmissionAnalytic from "app/store/dashboard/transmission_analytic/slice/transmissionAnalyticSlice";
import accountAnalytic from "app/store/dashboard/account_analytic/slice/accountAnalyticSlice";
import patientComplianceAnalytic from "app/store/dashboard/patient_compliance_analytic/slice/patientComplianceAnalyticSlice";

import auth from "app/store/auth/slice/authSlice";
import deviceTypes from "app/store/deviceTypes/slice/deviceTypes.slice";
import manufacturers from "app/store/manufacturers/slice/manufacturers.slice";
import account from "app/store/account/slice/accountSlice";
import patientProfileDocument from "app/store/patientProfile/documents/slice/patientProfileDocumentSlice";

import manualUpload from "app/store/manualUpload/slice/manualUploadSlice";
import archiveReport from "app/store/archiveReport/slice/archiveReportSlice";
import userActivityLog from "app/store/userActivityLog/slice/userActivityLogSlice";
import users from "app/store/user/slice/userSlice";
import rpmPatient from "app/store/rpmPatients/slice/rpmPatientsSlice";
import task from "app/store/tasks/slice/taskSlice";
import rpm from "app/store/rpm/slice/rpmSlice";
import device from "app/store/devices/slice/deviceSlice";
import liveCallTasks from "app/store/liveCallTasks/slice/liveCallTasksSlice";

import accountPreference from "app/store/accountPreference/slice/accountPreferenceSlice";
import notificationPreference from "app/store/notificationPreference/slice/notificationPreferenceSlice";

import accounts from "./accounts";
import alerts from "./alerts";

import appTheme from "./appTheme";
import patients from "./patients";
import upload from "./upload";

import { transmissionTableApi } from "app/store/transmission/api/transmissionTableApi";
import { transmissionNotesApi } from "app/store/transmission/api/transmissionNotesApi";
import { transmissionDetailApi } from "app/store/transmission/api/transmissionDetailApi";
import { devicesApi } from "app/store/devices/deviceApi";
import { insuranceApi } from "app/store/insurance/api/insuranceApi";
import { patientApi } from "app/store/patient/api/patientApi";
import { resetPasswordApi } from "app/store/auth/api/resetPasswordApi";
import { patientProfileDocumentApi } from "app/store/patientProfile/documents/api/patientProfileDocumentApi";
import { manufacturerApi } from "app/store/manufacturers/api/manufacturersApi";
import { archiveReportApi } from "app/store/archiveReport/api/archiveReportApi";
import { accountPreferenceApi } from "app/store/accountPreference/api/accountPreferenceApi";
import { patientProfileReportApi } from "app/store/patientProfile/reports/api/patientProfileReportApi";
import { accountDocumentApi } from "app/store/accountDocument/api/accountDocumentApi";
import { adtApi } from "app/store/adt/api/adtApi";
import ehrJobs from "app/store/ehrJobs/slice/ehrSlice";
import insurance from "app/store/insurance/slice/insuranceSlice";
import referringProvider from "app/store/referringProvider/slice/referringProviderSlice";
import alertProtocol from "app/store/alertProtocol/slice/alertProtocolSlice";
import { notificationPreferenceApi } from "app/store/notificationPreference/api/notificationPreferenceApi";
import { patientProfileTaskApi } from "app/store/patientProfile/tasks/api/patientProfileTaskApi";
import { subscriptionLogApi } from "app/store/patientProfile/tasks/subscription/subscriptionLogApi";
import { jobApi } from "app/store/ehrJobs/api/jobApi";
import { tasksApi } from "app/store/tasks/api/taskApi";
import { accountAnalyticApi } from "app/store/dashboard/account_analytic/api/accountAnalyticApi";
import { patientComplianceAnalyticApi } from "app/store/dashboard/patient_compliance_analytic/api/patientComplianceAnalyticApi";
import { hl7JobsApi } from "app/services/job/hl7Jobs";
import { referringProviderApi } from "app/store/referringProvider/api/referringProviderApi";
import { userApi } from "app/store/user/api/userApi";
import { rpmApi } from "app/store/rpm/api/rpmApi";
import billableIntervalAnalytic from "app/store/dashboard/billable_interval_analytic/slice/billableIntervalAnalyticSlice";
import quickTextTemplate from "app/store/quickTextTemplates/slice/quickTextTemplateSlice";
import { billableIntervalAnalyticApi } from "app/store/dashboard/billable_interval_analytic/api/billableIntervalAnalyticApi";
import { userActivityLogApi } from "app/store/userActivityLog/api/userActivityLogApi";
import nonCompliantPatient from "app/store/nonCompliantPatient/slice/nonCompliantPatientSlice";
import { liveCallTasksApi } from "app/store/liveCallTasks/api/liveCallTasksApi";
import { quickTextTemplateApi } from "app/store/quickTextTemplates/api/quickTextTemplateApi";
import { alertProtocolApi } from "app/store/alertProtocol/api/alertProtocolApi";
import { letterTemplateApi } from "app/store/letterTemplate/api/letterTemplateApi";
import { notificationApi } from "app/store/notification/api/notificationApi";
import { RESET_APP_STATE } from "static/constants";

const appReducer = combineReducers({
  alerts,
  patients,
  upload,
  accounts,
  accountPreference,
  appTheme,
  [accountPreferenceApi.reducerPath]: accountPreferenceApi.reducer,
  [patientAnalyticApi.reducerPath]: patientAnalyticApi.reducer,
  [doctorAnalyticApi.reducerPath]: doctorAnalyticApi.reducer,
  [manufacturerListApi.reducerPath]: manufacturerListApi.reducer,
  [electronicDeviceApi.reducerPath]: electronicDeviceApi.reducer,
  [transmissionAnalyticApi.reducerPath]: transmissionAnalyticApi.reducer,
  [surgeryProcedureApi.reducerPath]: surgeryProcedureApi.reducer,
  [billingAmountApi.reducerPath]: billingAmountApi.reducer,
  [revenueAnalyticApi.reducerPath]: revenueAnalyticApi.reducer,
  [accountAnalyticApi.reducerPath]: accountAnalyticApi.reducer,
  [transmissionTableApi.reducerPath]: transmissionTableApi.reducer,
  [transmissionDetailApi.reducerPath]: transmissionDetailApi.reducer,
  [transmissionNotesApi.reducerPath]: transmissionNotesApi.reducer,
  [devicesApi.reducerPath]: devicesApi.reducer,
  [insuranceApi.reducerPath]: insuranceApi.reducer,
  [patientApi.reducerPath]: patientApi.reducer,
  [resetPasswordApi.reducerPath]: resetPasswordApi.reducer,
  [patientProfileDocumentApi.reducerPath]: patientProfileDocumentApi.reducer,
  [letterTemplateApi.reducerPath]: letterTemplateApi.reducer,
  [patientProfileReportApi.reducerPath]: patientProfileReportApi.reducer,
  [accountDocumentApi.reducerPath]: accountDocumentApi.reducer,
  [subscriptionLogApi.reducerPath]: subscriptionLogApi.reducer,
  [manufacturerApi.reducerPath]: manufacturerApi.reducer,
  [archiveReportApi.reducerPath]: archiveReportApi.reducer,
  [adtApi.reducerPath]: adtApi.reducer,
  [patientComplianceAnalyticApi.reducerPath]:
    patientComplianceAnalyticApi.reducer,
  [notificationPreferenceApi.reducerPath]: notificationPreferenceApi.reducer,
  [jobApi.reducerPath]: jobApi.reducer,
  [hl7JobsApi.reducerPath]: hl7JobsApi.reducer,
  [patientProfileTaskApi.reducerPath]: patientProfileTaskApi.reducer,
  [tasksApi.reducerPath]: tasksApi.reducer,
  [referringProviderApi.reducerPath]: referringProviderApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [rpmApi.reducerPath]: rpmApi.reducer,
  [billableIntervalAnalyticApi.reducerPath]:
    billableIntervalAnalyticApi.reducer,
  [userActivityLogApi.reducerPath]: userActivityLogApi.reducer,
  [liveCallTasksApi.reducerPath]: liveCallTasksApi.reducer,
  [quickTextTemplateApi.reducerPath]: quickTextTemplateApi.reducer,
  [alertProtocolApi.reducerPath]: alertProtocolApi.reducer,
  [notificationApi.reducerPath]: notificationApi.reducer,
  transmission,
  patient,
  patientAnalytic,
  transmissionAnalytic,
  accountAnalytic,
  patientComplianceAnalytic,
  doctorAnalytic,
  surgeryProcedure,
  billingAmount,
  auth,
  deviceTypes,
  manufacturers,
  account,
  patientProfileDocument,
  manualUpload,
  archiveReport,
  userActivityLog,
  users,
  ehrJobs,
  rpmPatient,
  notificationPreference,
  task,
  rpm,
  device,
  insurance,
  billableIntervalAnalytic,
  referringProvider,
  nonCompliantPatient,
  liveCallTasks,
  quickTextTemplate,
  alertProtocol,
});

const rootReducer = (state, action) => {
  if (action.type === RESET_APP_STATE) {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
